import React from 'react';
import PartnerContainer from 'containers/PartnerContainer';

export default function PartnerPage() {
  return (
    <PartnerContainer />
  )
}
